export default __webpack_public_path__ + "static/ktx-logo-1842f1e3d3fb9a6680433dfd33bbd194.svg";